import { ApiService } from "../..";

export const updateSampleGroup = (
  groupId: string,
  data: {
    name?: string;
    description?: string;
  }
) => {
  return ApiService.baseAction(
    "sample-group/update/" + groupId,
    { data },
    "post"
  );
};
